export default {
  mpAuth: {
    url: '/wechat/auth/mpAuth',
    method: 'post'
  },
  qrcodeLogin: {
    url: '/wechat/auth/qrcodeLogin',
    method: 'post'
  },
  getWeappCode: {
    url: '/api/auth/getWeappCode',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/wechat.js